import A from '../../constants/actions';

const state = {
};

const actions = {

  [A.LOGGER_ADD_MSG]({dispatch}, log) {
    console.log('[' + log.level.name + ']', log.date, log.user, log.message);
    // TODO: send logs to server
  },

};

const mutations = {

};

const getters = {};

export default {
  state,
  actions,
  getters,
  mutations,
};